/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateGoogleCalendarInput = {
    id?: string | null | undefined;
    viewPrivateEvents?: boolean | null | undefined;
    enabledCalendarIds?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type UpdateGoogleCalendarMutationVariables = {
    input: UpdateGoogleCalendarInput;
};
export type UpdateGoogleCalendarMutationResponse = {
    readonly updateGoogleCalendar: {
        readonly googleCalendar: {
            readonly calendarViewPrivateEvents: boolean | null;
            readonly enabledCalendars: ReadonlyArray<string | null> | null;
        } | null;
    } | null;
};
export type UpdateGoogleCalendarMutation = {
    readonly response: UpdateGoogleCalendarMutationResponse;
    readonly variables: UpdateGoogleCalendarMutationVariables;
};



/*
mutation UpdateGoogleCalendarMutation(
  $input: UpdateGoogleCalendarInput!
) {
  updateGoogleCalendar(input: $input) {
    googleCalendar {
      calendarViewPrivateEvents
      enabledCalendars
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateGoogleCalendarInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calendarViewPrivateEvents",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabledCalendars",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateGoogleCalendarMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateGoogleCalendarPayload",
        "kind": "LinkedField",
        "name": "updateGoogleCalendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarIntegration",
            "kind": "LinkedField",
            "name": "googleCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateGoogleCalendarMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateGoogleCalendarPayload",
        "kind": "LinkedField",
        "name": "updateGoogleCalendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarIntegration",
            "kind": "LinkedField",
            "name": "googleCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UpdateGoogleCalendarMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateGoogleCalendarMutation(\n  $input: UpdateGoogleCalendarInput!\n) {\n  updateGoogleCalendar(input: $input) {\n    googleCalendar {\n      calendarViewPrivateEvents\n      enabledCalendars\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e276a3984a4ee25289bc5555ef722d3c';
export default node;
